import { select } from 'redux-saga/effects';
import { hasModule } from '../../../utils/capabilitiesHelper';

/** @returns {Generator<*, boolean, *>} */
export function* ensureWhatsAppModuleAccess() {
  const isAuthenticated = yield select((state) => state.auth?.isAuthenticated);
  const capabilities = yield select((state) => state.capabilities?.capabilities);
  return Boolean(isAuthenticated && hasModule(capabilities, 'WHATSAPP'));
}
